import { EquipmentNavBar } from "./components/equipment-navbar/equipment-nav-bar.component";
import { EquipmentBody } from "./components/equipment-body/equipment-body.component";
import TopNavAndBody from "layouts/top-nav-and-body/top-nav-and-body";

const Equipment = () => {
  return <TopNavAndBody navigation={<div />} body={<EquipmentBody />} />;
};

export default Equipment;
